import { render, staticRenderFns } from "./AddStageTournament.vue?vue&type=template&id=3285f501&scoped=true"
import script from "./AddStageTournament.vue?vue&type=script&lang=js"
export * from "./AddStageTournament.vue?vue&type=script&lang=js"
import style0 from "./AddStageTournament.vue?vue&type=style&index=0&id=3285f501&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3285f501",
  null
  
)

export default component.exports